































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { WordSearchPuzzle } from '@/wordsearch/types';

const puzzle = namespace('Puzzle');

@Component
export default class WordListMobile extends Vue {
  @puzzle.State
  private puzzle!: WordSearchPuzzle;

  @puzzle.State
  private gridSize!: number;

  @puzzle.State
  private userAnswers!: Record<string, string[]>;

  @puzzle.State
  private selectedCells!: string[];

  @puzzle.Getter
  private selectedLetters!: string;

  get firstColumnWords() {
    return this.puzzle.words.slice(0, Math.ceil(this.puzzle.words.length * 0.5));
  }

  get secondColumnWords() {
    return this.puzzle.words.slice(Math.ceil(this.puzzle.words.length * 0.5));
  }

  get foundAnswers() {
    return Object.keys(this.userAnswers);
  }

  get wordListStyle() {
    return `
      width: ${this.gridSize}px;
      min-width: ${this.gridSize}px;
    `;
  }
}
